import { render, staticRenderFns } from "./veHqChurukuEdit.vue?vue&type=template&id=03158b10&scoped=true"
import script from "./veHqChurukuEdit.vue?vue&type=script&lang=js"
export * from "./veHqChurukuEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03158b10",
  null
  
)

export default component.exports